import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const GoogleAd = ({ id }) => {
    const { ADS_ACTIVE } = useSelector(state => state.initState);

    React.useEffect(() => {
        if (!ADS_ACTIVE) {
            return;
        }

        window.googletag.cmd.push(() => {
            window.googletag.display(id);
        });
    }, [id, ADS_ACTIVE]);

    if (!ADS_ACTIVE) {
        return null;
    }

    return <div id={id} style={{ textAlign: 'center', margin: '10px auto' }} />;
};

GoogleAd.propTypes = {
    id: PropTypes.string.isRequired
};

export default GoogleAd;
